export const ROUTES = {
  login: '/',
  main: '/main',
  location: '/location',
  profile: '/profile',
  profileNotifications: '/profile/notifications',
  categoryRoot: '/category',
  category: '/category/:categoryId',
  discountRoot: '/discount',
  discount: '/discount/:discountId',
  forbidden: '/forbidden',
  favorites: '/favorites',
  discountEditor: '/discount-editor',
  noDiscountsInLocation: '/empty',
  notFound: '/404',
  requestDiscount: '/request-discount',
  requestDiscountAll: '/discounts-request-list',
  requestDiscountFilters: '/discounts-request-list/filters',
  rolesManagement: '/roles-management',
  statistics: '/statistics',
  statisticsFilters: '/statistics/filters',
  archives: '/archives',
  noActive: '/noActive',
  aPlayer: '/a-player',
  latestDeals: '/latest-deals',
} as const;
